import React, { Fragment } from 'react';
import { useRouteMatch, Link } from 'react-router-dom';
import { Box, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ROUTES from '../../config/routes';

const useStyles = makeStyles((theme) => ({
  link: {
    '&:hover': {
      textDecoration: 'underline',
    },
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: theme.typography.fontWieghtNormal,
    fontSize: '1rem',
  },
}));

const Header = () => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  return (
    <Fragment>
      <Typography variant="h2" component="h1">
        Ladda ner kommunikationsmaterial
      </Typography>

      <Typography paragraph={true} variant="body2">
        Här samlar vi material för dig vill förmedla Världens bibliotek.
      </Typography>

      <Typography variant="h3" component="h2">
        Webb och digitala medier
      </Typography>
      <ul>
        <li>
          <Link to={`${path}/${ROUTES.CI_WEB_IMAGES}`} className={classes.link}>
            Bilder
          </Link>
        </li>
        <li>
          <Link
            to={`${path}/${ROUTES.CI_IMAGE_BUTTON}`}
            className={classes.link}
          >
            Digital knapp för webbsida
          </Link>
        </li>
        <li>
          <Link
            to={`${path}/${ROUTES.CI_PRESENTATIONS}`}
            className={classes.link}
          >
            Digital presentation
          </Link>
        </li>
      </ul>

      <Typography variant="h3" component="h2">
        Trycksaker
      </Typography>

      <ul>
        <li>
          <Link to={`${path}/${ROUTES.CI_POSTERS}`} className={classes.link}>
            Affischer
          </Link>
        </li>
        <li>
          <Link to={`${path}/${ROUTES.CI_BOOKMARKS}`} className={classes.link}>
            Bokmärken
          </Link>
        </li>
        <li>
          <Link to={`${path}/${ROUTES.CI_FLYERS}`} className={classes.link}>
            Flyers
          </Link>
        </li>
        <li>
          <Link to={`${path}/${ROUTES.CI_FOLDERS}`} className={classes.link}>
            Foldrar
          </Link>
        </li>
        <li>
          <Link
            to={`${path}/${ROUTES.CI_CHILDREN_GAMES}`}
            className={classes.link}
          >
            Pyssel
          </Link>
        </li>
        <li>
          <Link to={`${path}/${ROUTES.CI_POSTCARDS}`} className={classes.link}>
            Vykort
          </Link>
        </li>
      </ul>
      <Box pb={5} pt={5}>
        <Divider />
      </Box>
    </Fragment>
  );
};

export default React.memo(Header);
